import React from 'react';
import DisplayNavBar from 'component/display_navbar';
import DisplayContent from 'component/display_content';
import { DisplayDataStyle } from './DisplayDataStyle';

export default function DisplayData() {
  return (
    <div>
      <DisplayDataStyle className='af-display-data'>
        <DisplayNavBar />
        <DisplayContent />
      </DisplayDataStyle>
    </div>
  );
}
